<ng-template dynamicContainer [cdkPortalOutlet]="selectedPortal"></ng-template>
